import { configureStore } from "@reduxjs/toolkit";
import auth from "./features/authSlice"
import contracts from "./features/contractSlice"

export const store = configureStore({
    reducer: {
        auth: auth,
        contracts: contracts
    }
})